import BaseComponent from "../../../../lib/components/BaseComponent";
import LandingPage from "./LandingPage";
import RouterElement from "../../../../lib/components/router/RouterElement";

class LandingMain extends BaseComponent {

  render() {
    return <>
      <RouterElement route='^$|^landing'><LandingPage p={this}/></RouterElement>
    </>
  }
}

export default LandingMain;
